module.exports = __webpack_public_path__ + "img/campaigns_navbar_no_session.7114a8ee.svg";